<template>
  <div
    ref="modalRef"
    class="modal fade"
    id="modalSlider"
    tabindex="-1"
    aria-labelledby="modalSliderLabel"
    aria-hidden="true"
    :style="`top: ${position.top}px; left: ${position.left}px;`">
    <div class="modal-dialog m-0">
      <div v-if="dataObj" class="modal-content border-1 border border-link-text rounded-1" style="width: 319px;">
        <div class="m-title d-flex align-items-center justify-content-between ps-2 pe-1 fs-16 bg-link-text text-white" style="height: 24px;">
          <span id="modalSliderLabel">{{ getSchemeText(dataObj.scheme) }}</span>
          <button type="button" class="btn-close text-white action" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="m-content">
          <div
            v-for="(section, sectionIndex) of orderObj(dataObj[`tip_section_${scenarioMode[dataObj.scheme]}`], 'order')"
            :key="`section_${dataObj.scheme}_${sectionIndex}`">
            <div
              v-if="(modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].collapseMode[section.name] === false) && ((!section.is_hide_in_comparative) || (section.is_hide_in_comparative && mode === 'combined'))">
              <!-- Title -->
              <div class="bg-light-blue-grey1 d-flex flex-row">
                <!-- Default -->
                <p v-if="!section.edit_type || section.edit_type === 'week'" class="text-main-body-text text-start fw-bold p-1 ps-2 pb-0 mb-1 flex-grow-1">{{section.title}}</p>
                <div v-if="section.editable && !section.edit_type" class="d-flex align-items-center">
                  <span
                    v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === false"
                    class="edit-btn p-1 pe-2 text-link-text"
                    @click="onClickEdit(dataObj.scheme, section, true, scenarioMode[dataObj.scheme])">Edit</span>
                  <span
                    v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === true"
                    class="edit-btn p-1 pe-2 text-link-text"
                    @click="onClickEdit(dataObj.scheme, section, false, scenarioMode[dataObj.scheme])">Slider</span>
                </div>
                <!-- /Default -->
                <!-- Currency -->
                <p
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === false && section.edit_type === 'benefit_currency'"
                  class="text-main-body-text text-start fw-bold p-1 ps-2 pb-0 mb-1 flex-grow-1">
                  {{section.title}}
                </p>
                <p
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === true && section.edit_type === 'benefit_currency' && selectedObject[scenarioMode[dataObj.scheme]]"
                  class="text-main-body-text text-start fw-bold p-1 ps-2 pb-0 mb-1 flex-grow-1">
                  {{getCurrencyText(section.title_back, selectedObject[scenarioMode[dataObj.scheme]].country_obj)}}
                </p>
                <div v-if="section.editable && section.edit_type === 'benefit_currency'" class="d-flex align-items-center">
                  <span
                    v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === false && selectedObject[scenarioMode[dataObj.scheme]]"
                    class="edit-btn p-1 pe-2 text-link-text"
                    @click="onClickEdit(dataObj.scheme, section, true, scenarioMode[dataObj.scheme])">
                    {{getCurrencyText(section.edit_title, selectedObject[scenarioMode[dataObj.scheme]].country_obj)}}
                  </span>
                  <span
                    v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === true && selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_currency < getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).max"
                    class="edit-btn p-1 pe-2 text-link-text"
                    @click="onClickEdit(dataObj.scheme, section, false, scenarioMode[dataObj.scheme])">
                    {{section.edit_title_back}}
                  </span>
                </div>
                 <!-- /Currency -->
                <button
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].collapseMode[section.name] === false"
                  type="button"
                  class="close-btn border-0"
                  @click="onClickCollapse($event, dataObj.scheme, section, true, scenarioMode[dataObj.scheme])">
                  <i class="uil uil-multiply text-primary" style="font-size: 18px;"></i>
                </button>
              </div>
              <!-- /Title -->
              <!-- Toggle -->
              <div v-if="section.toggleable === true">
                <div class="form-check form-check-inline mx-2 mt-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :name="`toggle_${dataObj.scheme}_${section.name}`"
                    :id="`toggle_${dataObj.scheme}_${section.name}`"
                    @change="handleToggleChanged(section.name,
                      modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].toggleMode[section.name],
                      scenarioMode[dataObj.scheme],
                      dataObj.scheme,
                      selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name])"
                    v-model="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].toggleMode[section.name]"
                    :checked="getToggleStatus(scenarioMode[dataObj.scheme], dataObj.scheme, section.name)">
                  <label
                    class="form-check-label"
                    :for="`toggle_${dataObj.scheme}_${section.name}`">{{section.toggle_text}}</label>
                </div>
              </div>
              <div v-if="(!section.toggleable) || (section.toggleable === true && modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].toggleMode[section.name] === true)">
                <!-- Inner Title -->
                <div v-if="section.inner_title">
                  <p class="text-main-body-text text-start fw-bold p-1 ps-2 pb-0 mb-1">{{section.inner_title}}</p>
                </div>
                <!-- /Inner Title -->
                <!-- Slider -->
                <div
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === false
                    && selectedObject[scenarioMode[dataObj.scheme]]
                    && selectedObject[scenarioMode[dataObj.scheme]].scheme_details
                    && section.slider_settings"
                  class="px-3 py-6 pt-8">
                  <div
                    v-if="section.slider_settings.slider_title"
                    class="mb-8 fs-14 mt-n8">
                    <b>{{section.slider_settings.slider_title}}</b>
                  </div>
                  <div v-if="section.name !== 'benefit_currency'">
                    <vue-slider
                    :key="`slider_${section.edit_type}_slider`"
                    :min="section.slider_settings.min"
                    :max="section.slider_settings.max"
                    :interval="section.slider_settings.interval"
                    :tooltip="'always'"
                    :lazy="true"
                    :enable-cross="false"
                    :adsorb="false"
                    :dot-style="{ background: '#DFE2EB', border: '2px solid #66CC33' }"
                    :process-style="{ background: '#66CC33'}"
                    :tooltip-style="{ background: '#66CC33', borderColor: '#66CC33'}"
                    :step-style="{ display: 'none'}"
                    :rail-style="{ background: '#DFE2EB'}"
                    :marks="section.slider_settings.marks"
                    v-model="selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name]"
                    @change="handleSelectChanged()"></vue-slider>
                  </div>

                  <div v-if="section.name === 'benefit_currency'">
                    <vue-slider
                    :key="`slider_${section.edit_type}_slider_currency`"
                    :min="getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).min"
                    :max="getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).max"
                    :interval="section.slider_settings.interval"
                    :tooltip="'always'"
                    :lazy="true"
                    :enable-cross="false"
                    :adsorb="false"
                    :dot-style="{ background: '#DFE2EB', border: '2px solid #66CC33' }"
                    :process-style="{ background: '#66CC33'}"
                    :tooltip-style="{ background: '#66CC33', borderColor: '#66CC33'}"
                    :step-style="{ display: 'none'}"
                    :rail-style="{ background: '#DFE2EB'}"
                    :marks="getCustomMarks(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme)"
                    v-model="selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name]"
                    @change="onCurrencyChange(
                    {
                      target:{
                        value: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name],
                        min: getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).min,
                        isCustomeLogic: true
                      }
                    },
                    dataObj.scheme, section, scenarioMode[dataObj.scheme])"></vue-slider>
                  </div>
                </div>
                <!-- /Slider -->
                <!-- Edit -->
                <div
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === true && !section.edit_type">
                  <div
                    v-if="Array.isArray(selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name])"
                    class="d-flex flex-row align-items-center">
                    <div class="d-flex flex-column m-2 flex-grow-1">
                      <label
                      :for="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                      class="form-label text-start text-grey-additional">From</label>
                      <input
                        type="number"
                        class="form-control"
                        :name="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                        :min="section.slider_settings.min"
                        :max="section.slider_settings.max"
                        v-on:change="inputNumberValidation($event, dataObj.scheme, section, section.slider_settings.min, 0, scenarioMode[dataObj.scheme])"
                        v-model.number="selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name][0]">
                    </div>
                    <span class="text-grey-additional">-</span>
                    <div class="d-flex flex-column m-2 flex-grow-1">
                      <label
                        :for="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                        class="form-label text-start text-grey-additional">To</label>
                      <input
                        type="number"
                        class="form-control"
                        :name="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                        :min="section.slider_settings.min"
                        :max="section.slider_settings.max"
                        v-on:change="inputNumberValidation($event, dataObj.scheme, section, section.slider_settings.max, 1, scenarioMode[dataObj.scheme])"
                        v-model.number="selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name][1]">
                    </div>
                  </div>
                  <div
                    v-if="Array.isArray(selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name]) === false"
                    class="d-flex flex-column m-2">
                    <label
                      :for="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                      class="form-label text-start text-grey-additional">Enter exact amount</label>
                    <input
                      type="number"
                      class="form-control"
                      :name="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                      :min="section.slider_settings.min"
                      :max="section.slider_settings.max"
                      v-on:change="inputNumberValidation($event, dataObj.scheme, section, section.slider_settings.min, undefined, scenarioMode[dataObj.scheme])"
                      v-model.number="selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name]">
                  </div>
                </div>
                <!-- /Edit -->
                <!-- Edit Currency -->
                <div
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === true && section.edit_type === 'benefit_currency'">
                  <div
                    v-if="selectedObject[scenarioMode[dataObj.scheme]] && Array.isArray(selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name]) === false"
                    class="d-flex flex-column m-2">
                    <label
                      :for="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                      class="form-label text-start text-grey-additional">
                      Enter amount in Local Currency
                      <!-- Enter amount in Local Currency ({{`${getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).min} - ${getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).max.toLocaleString()}`}}) -->
                    </label>
                    <input
                      v-if="dataObj.scheme === '70001' || dataObj.scheme === '70002' || dataObj.scheme === '70003' || dataObj.scheme === '70004'"
                      type="number"
                      class="form-control"
                      :name="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                      :min="getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).min"
                      v-on:change="onCurrencyChange($event, dataObj.scheme, section, scenarioMode[dataObj.scheme])"
                      v-model.number="selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_currency">
                    <!-- <input
                      v-if="dataObj.scheme === '70004'"
                      type="number"
                      class="form-control"
                      :name="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}_edit`"
                      :min="getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).min"
                      v-on:change="onCurrencyChange($event, dataObj.scheme, section, scenarioMode[dataObj.scheme])"
                      :value="getCurrencyRoundNumber(selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_currency, getCurrencyRange(selectedObject[scenarioMode[dataObj.scheme]].country_obj.name, dataObj.scheme).basicMat)"> -->
                  </div>
                </div>
                <!-- /Edit Currency -->
                <!-- Shortcut -->
                <div
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === false && section.shortcut_marks"
                  class="d-flex flex-row p-2">
                  <div
                    v-for="(shortcut, shortcutIndex) of section.shortcut_marks"
                    :key="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}`"
                    class="shortcut-btn pe-2"
                    @click="onClickShortcut(dataObj.scheme, section, shortcut, scenarioMode[dataObj.scheme], shortcutIndex)">
                    <img :src="shortcut.thumbnail" class="pe-1" /><span class="text-grey-additional">{{shortcut.name}}</span>
                  </div>
                </div>
                <!-- /Shortcut -->
                <!-- Custom double slider -->
                <div
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name_2] === false
                    && selectedObject[scenarioMode[dataObj.scheme]]
                    && selectedObject[scenarioMode[dataObj.scheme]].scheme_details
                    && section.slider_settings_2"
                  class="px-3 py-6 pt-3">
                  <div
                    v-if="section.slider_settings_2.slider_title"
                    class="mb-8 fs-14">
                    <b>{{section.slider_settings_2.slider_title}}</b>
                  </div>
                  <vue-slider
                  :key="`slider_${section.edit_type}_slider_2`"
                  :min="section.slider_settings_2.min"
                  :max="section.slider_settings_2.max"
                  :interval="section.slider_settings_2.interval"
                  :tooltip="'always'"
                  :lazy="true"
                  :enable-cross="false"
                  :adsorb="false"
                  :dot-style="{ background: '#DFE2EB', border: '2px solid #66CC33' }"
                  :process-style="{ background: '#66CC33'}"
                  :tooltip-style="{ background: '#66CC33', borderColor: '#66CC33'}"
                  :step-style="{ display: 'none'}"
                  :rail-style="{ background: '#DFE2EB'}"
                  :marks="section.slider_settings_2.marks"
                  v-model="selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0][section.name_2]"
                  @change="handleSelectChanged()"></vue-slider>
                </div>
                <!-- /Custom double slider -->
                <!-- Shortcut2 -->
                <div
                  v-if="modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === false && section.shortcut_marks_2"
                  class="d-flex flex-row p-2"
                  style="font-size: 11px;">
                  <div
                    v-for="(shortcut, shortcutIndex) of section.shortcut_marks_2"
                    :key="`section_${dataObj.scheme}_${sectionIndex}_${shortcutIndex}`"
                    class="shortcut-btn pe-1"
                    :class="{'col-6': shortcutIndex == 0, 'col-7': shortcutIndex == 1}"
                    @click="onClickShortcut(dataObj.scheme, section, shortcut, scenarioMode[dataObj.scheme], shortcutIndex, true)">
                    <img :src="shortcut.thumbnail" class="pe-1" /><span class="text-grey-additional d-inline-flex w-75">{{shortcut.name}}</span>
                  </div>
                </div>
                <!-- /Shortcut2 -->
                <!-- Information -->
                <p
                  v-if="section.benefit_info || section.benefit_info_back || section.info"
                  class="fw-light m-0 px-2 pb-2">
                  <span
                    class="text_section_benefit_info"
                    v-if="section.benefit_info &&
                      modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === false &&
                      ['benefit_currency','week'].indexOf(section.edit_type) > -1 &&
                      selectedObject[scenarioMode[dataObj.scheme]]"
                    v-html="getBenefitText(section.benefit_info, {
                      ppp: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_ppp,
                      currency: selectedObject[scenarioMode[dataObj.scheme]].country_obj.field_currency_code,
                      benefit_currency: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_currency,
                      benefit_percent: getRoundNumber(selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_percent, 2),
                      week: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].week
                    })">
                  </span>
                  <span
                    class="text_section_benefit_info_back"
                    v-if="section.benefit_info_back &&
                      modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].editMode[section.name] === true &&
                      ['benefit_currency','week'].indexOf(section.edit_type) > -1 &&
                      selectedObject[scenarioMode[dataObj.scheme]]"
                    v-html="getBenefitText(section.benefit_info_back, {
                      ppp: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_ppp,
                      benefit_percent: getRoundNumber(selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_percent, 2),
                      week: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].week
                    })">
                  </span>
                  <span
                    class="text_section_info"
                    v-if="section.info &&
                      selectedObject[scenarioMode[dataObj.scheme]]"
                    v-html="getBenefitText(section.info, {
                      ppp: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_ppp,
                      benefit_percent: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].benefit_percent,
                      week: selectedObject[scenarioMode[dataObj.scheme]].scheme_details.filter(s => s.scheme === dataObj.scheme)[0].week
                    })">
                  </span>
                </p>
                <p
                  v-if="section.name==='benefit_percent'"
                  class="fw-light m-0 px-2 pb-2">
                  {{dataObj.existingScheme[scenarioMode[dataObj.scheme]]}}
                </p>
                <!-- /Information -->
              </div>
              <!-- /Toggle -->
            </div>
            <!-- Collapse view -->
            <div
              v-if="(modeStatus[scenarioMode[dataObj.scheme]][dataObj.scheme].collapseMode[section.name] === true) && ((!section.is_hide_in_comparative) || (section.is_hide_in_comparative && mode === 'combined'))"
              class="d-flex flex-row m-2 bg-light-blue-grey1">
              <button
                type="button"
                class="plus-btn border-0"
                @click="onClickCollapse($event, dataObj.scheme, section, false, scenarioMode[dataObj.scheme])">
                <i class="uil uil-plus-circle text-primary" style="font-size: 18px;"></i>
              </button>
              <p class="text-main-body-text text-start fw-bold p-1 ps-2 pb-0 mb-1">{{section.title}}</p>
            </div>
            <!-- /Collapse view -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapActions } from 'vuex';
import { getSchemeText } from '../helper';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    VueSlider
  },
  props: {
    selectedScheme: {
      type: String
    },
    data: {
      type: Array
    },
    modeStatusA: {
      type: Object
    },
    selectedObjectA: {
      type: Object
    },
    position: {
      type: Object
    },
    mode: {
      type: String
    }
  },
  data: function () {
    return {
      bsModal: null,
      dataObj: undefined,
      getSchemeText,
      modeStatus: {},
      selectedObject: {},
      scenarioMode: {
        70001: 's1',
        70002: 's1',
        70003: 's1',
        70004: 's1'
      },
      benefitMode: 'currency', // percent || currency
      benefitMetadata: [],
      benefitPercentageRanges: {
        70001: {
          min: 0,
          max: 16
        },
        70002: {
          min: 0,
          max: 60
        },
        70003: {
          min: 0,
          max: 60
        },
        70004: {
          min: 0,
          max: 52
        }
      }
    };
  },
  watch: {
    selectedScheme: async function () {
      this.formatData();
      this.formatModeStatusData();
      await this.formatSelectedObjectData();
    },
    selectedObjectA: {
      handler: async function () {
        this.formatData();
        this.formatModeStatusData();
        await this.formatSelectedObjectData();
      },
      deep: true
    },
    mode: function () {
      this.updateMode();
    }
  },
  mounted: function () {
    this.initialize();
  },
  methods: {
    ...mapActions('analysis', [
      'getCountryById',
      'getBenefitCurrencyData',
      'getBenefitPercentageData',
      'getBenefitMetadata'
    ]),
    initialize: function () {
      this.fetchData();
      this.initModal();
    },
    initModal: function () {
      const modalRef = this.$refs.modalRef;
      this.bsModal = new window.bootstrap.Modal(modalRef, { backdrop: true });
    },
    fetchData: async function () {
      this.benefitMetadata = await this.getBenefitMetadata({
        childMinPercentage: this.benefitPercentageRanges['70001'].min,
        childMaxPercentage: this.benefitPercentageRanges['70001'].max,
        disabilityMinPercentage: this.benefitPercentageRanges['70002'].min,
        disabilityMaxPercentage: this.benefitPercentageRanges['70002'].max,
        oldAgeMinPercentage: this.benefitPercentageRanges['70003'].min,
        oldAgeMaxPercentage: this.benefitPercentageRanges['70003'].max,
        maternityMinPercentage: this.benefitPercentageRanges['70004'].min,
        maternityMaxPercentage: this.benefitPercentageRanges['70004'].max
      });
    },
    onScenarioCheckboxChange: function (event, schemeId, selectedScenario, status) {
      event.stopPropagation();
      if (selectedScenario === 's1') {
        this.selectedObjectA.scheme_details.map(d => {
          if (d.scheme === schemeId) {
            d.is_selected = status;
          }
          return d;
        });
      }

      this.handleSelectChanged();
    },

    handleSelectChanged: _.debounce(function () {
      // console.log('handleSelectChanged !!');
      this.$emit('selectedChanged', {});
    }, 500),
    handleToggleChanged: function (sectionName, toggleValue, scenario, scheme, value) {
      if (sectionName === 'pmt') {
        // if (toggleValue === false && value !== 100) {
        //   this.selectedObject[scenario].scheme_details.find(d => d.scheme === scheme)[sectionName] = 100;
        //   this.handleSelectChanged();
        // }
        this.selectedObject[scenario].scheme_details.find(d => d.scheme === scheme)[sectionName] = toggleValue;
        this.handleSelectChanged();
      } else if (sectionName === 'pt') {
        this.selectedObject[scenario].scheme_details.find(d => d.scheme === scheme)[sectionName] = toggleValue;
        this.handleSelectChanged();
      }
    },
    getToggleStatus: function (scenario, scheme, sectionName) {
      let result = false;
      if (this.selectedObject[scenario]) {
        if (sectionName === 'pt') {
          const bool = this.selectedObject[scenario].scheme_details.find(d => d.scheme === scheme)[sectionName];
          if (bool !== undefined) {
            result = bool;
            this.modeStatus[scenario][scheme].toggleMode[sectionName] = bool;
          }
        } else if (sectionName === 'pmt') {
          const bool = this.selectedObject[scenario].scheme_details.find(d => d.scheme === scheme)[sectionName];
          if (bool !== undefined) {
            result = bool;
            this.modeStatus[scenario][scheme].toggleMode[sectionName] = bool;
          }
        } else {
          if (this.selectedObject[scenario].scheme_details.find(d => d.scheme === scheme)[sectionName] !== 100) {
            this.modeStatus[scenario][scheme].toggleMode[sectionName] = true;
            result = true;
          }
        }
      }
      return result;
    },
    formatData: function () {
      const targetScheme = this.data.filter(d => d.scheme === this.selectedScheme);
      if (targetScheme.length > 0) {
        this.dataObj = targetScheme[0];
      }
    },
    formatModeStatusData: function () {
      this.modeStatus = {
        s1: this.modeStatusA
      };
    },
    formatSelectedObjectData: _.debounce(async function (e) {
      // Add country obj
      this.selectedObjectA.country_obj = await this.getCountryById(this.selectedObjectA.country);

      // Add benefit infoGraphicData
      this.selectedObject = {
        s1: this.selectedObjectA
      };
      this.onBenefitChange();
      this.handleSelectChanged();
    }, 500),
    getBenefitText: function (template, benefitObj) {
      let result = template;
      const keys = Object.keys(benefitObj);
      // console.log('benefitObj', benefitObj);
      for (const key of keys) {
        let replaceText = benefitObj[key];
        if (key === 'benefit_currency') {
          replaceText = benefitObj[key].toLocaleString();
        }
        result = result.replace(`[[${key}]]`, replaceText);
      }
      return result;
    },
    getBenefitCurrencyObj: async function (countryName, percentage, schemeId, maternityWeek) {
      const benefitCurrencyTemp = await this.getBenefitCurrencyData({ countryName, percentage, schemeId, maternityWeek });
      const benefitCurrency = JSON.parse(benefitCurrencyTemp[0]);
      return benefitCurrency;
    },
    getBenefitPercentageObj: async function (countryName, currencyAmount, schemeId, maternityWeek) {
      const benefitPercentageTemp = await this.getBenefitPercentageData({ countryName, currencyAmount, schemeId, maternityWeek });
      const benefitPercentage = JSON.parse(benefitPercentageTemp[0]);
      return benefitPercentage;
    },
    onClickShortcut: function (schemeId, tipSection, shortcut, selectedScenario, shortcutIndex, isShortcut2 = false) {
      if (tipSection.name === 'benefit_currency') {
        const currencyObj = this.getCurrencyRange(this.selectedObject[this.scenarioMode[this.dataObj.scheme]].country_obj.name, this.dataObj.scheme);
        // console.log(schemeId, tipSection, shortcut, selectedScenario, shortcutIndex);
        if (shortcutIndex === 1) {
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_currency = currencyObj.advancedMat;
        } else {
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_currency = currencyObj.basicMat;
        }

        if (tipSection.shortcut_marks_2) {
          const value2 = _.cloneDeep(tipSection.shortcut_marks_2[shortcutIndex].value);
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0][tipSection.name_2] = value2;
        }

        this.onCurrencyChange(
          {
            target: {
              value: this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_currency,
              min: currencyObj.min,
              isCustomeLogic: true
            }
          },
          this.dataObj.scheme, tipSection, this.scenarioMode[this.dataObj.scheme]);

        this.handleSelectChanged();
      } else if (isShortcut2) {
        if (tipSection.shortcut_marks_2) {
          const value2 = _.cloneDeep(tipSection.shortcut_marks_2[shortcutIndex].value);
          // console.log(value2);
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0][tipSection.name_2] = value2;
        }
        this.handleSelectChanged();
      } else {
        this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0][tipSection.name] = shortcut.value;

        // if (tipSection.shortcut_marks_2) {
        //   const value2 = _.cloneDeep(tipSection.shortcut_marks_2[shortcutIndex].value);
        //   this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0][tipSection.name_2] = value2;
        // }

        this.handleSelectChanged();
      }
      // console.log(tipSection);
    },
    onClickEdit: function (schemeId, tipSection, selectedValue, selectedScenario) {
      this.modeStatus[selectedScenario][schemeId].editMode[tipSection.name] = selectedValue;
    },
    onClickCollapse: function (event, schemeId, tipSection, selectedValue, selectedScenario) {
      event.stopPropagation();

      // Collapse other section when small screen
      if (window.innerHeight < 1076) {
        _.each(this.modeStatus[selectedScenario][schemeId].collapseMode, (v, k) => {
          if (k !== tipSection.name) {
            this.modeStatus[selectedScenario][schemeId].collapseMode[k] = true;
          }
        });
      }
      this.modeStatus[selectedScenario][schemeId].collapseMode[tipSection.name] = selectedValue;
    },
    onCurrencyChange: async function (event, schemeId, tipSection, selectedScenario) {
      if (!event.target.value || event.target.value === '') {
        return;
      }
      // console.log('onCurrencyChange !!');
      this.benefitMode = 'currency';
      let val;
      let min;
      if (event.target.isCustomeLogic) {
        val = Number(event.target.value);
        min = Number(event.target.min);
      } else {
        val = Number(event.target.value);
        min = Number(event.target.getAttribute('min'));
      }
      // const max = Number(event.target.getAttribute('max'));

      let selectedObj;
      if (selectedScenario === 's1') {
        selectedObj = _.cloneDeep(this.selectedObjectA);
      }

      if (val < min) {
        if (val < min) {
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_currency = min;
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_percent = min;
        }
        //  else if (val > max) {
        //   const maxPercentage = this.benefitPercentageRanges[schemeId].max;
        //   this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_currency = max;
        //   this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_percent = maxPercentage;
        // }
      } else {
        const schemeObj = selectedObj.scheme_details.filter(s => s.scheme === schemeId)[0];
        schemeObj.benefit_currency = val;
        const benefitPercentageObj = await this.getBenefitPercentageObj(selectedObj.country_obj.name, val, schemeId, schemeObj.week);

        this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_percent = this.getRoundNumber(benefitPercentageObj.percent, 10);
        this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0].benefit_ppp = benefitPercentageObj.ppp_equivalent;
      }
      this.handleSelectChanged();
    },
    onBenefitChange: function () {
      const schemes = [70001, 70002, 70004, 70003];
      const scenarios = ['s1'];
      // console.log('this.modeStatus', _.cloneDeep(this.modeStatus));

      for (const scenario of scenarios) {
        let selectedObj;
        if (scenario === 's1') {
          selectedObj = _.cloneDeep(this.selectedObjectA);
        }
        for (const scheme of schemes) {
          if (this.modeStatus && this.modeStatus[scenario]) {
            const isChangePercentage = !this.modeStatus[scenario][scheme].editMode.benefit_percent;
            this.updateBenefit(isChangePercentage, scenario, scheme.toString());
          }
        }
      }
    },
    verifyCurrencyValue: async function (scenario, scheme) {
      let selectedObj;
      if (scenario === 's1') {
        selectedObj = _.cloneDeep(this.selectedObjectA);
      } else {
        selectedObj = _.cloneDeep(this.selectedObjectB);
      }

      const currencyRange = this.getCurrencyRange(selectedObj.country_obj.name, scheme);
      const target = selectedObj.scheme_details.find(d => d.scheme === String(scheme));

      if (target.benefit_currency > currencyRange.max ||
        target.benefit_currency < currencyRange.min) {
        if (this.selectedObject[scenario]) {
          this.selectedObject[scenario].scheme_details.filter(s => s.scheme === scheme)[0].benefit_currency = currencyRange.basicMat;
        }
      }
    },
    updateBenefit: async function (isChangePercentage, scenario, scheme) {
      let selectedObj;
      if (scenario === 's1') {
        selectedObj = _.cloneDeep(this.selectedObjectA);
      }
      const currencyRange = this.getCurrencyRange(selectedObj.country_obj.name, scheme);
      const target = selectedObj.scheme_details.find(d => d.scheme === String(scheme));
      if (target) {
        if (isChangePercentage) {
          const percentageRange = this.benefitPercentageRanges[scheme];
          if (target.benefit_percent < percentageRange.min) {
            target.benefit_percent = percentageRange.min;
          } else if (target.benefit_percent > percentageRange.max) {
            target.benefit_percent = percentageRange.max;
          }
          const benefitCurrencyObj = await this.getBenefitCurrencyObj(selectedObj.country_obj.name, target.benefit_percent, target.scheme, target.week);
          let newCurrency = this.getRoundNumber(benefitCurrencyObj.local_currency, 1);

          // if (scheme === '70004') {
          //   // newCurrency = benefitCurrencyObj.transfer_week;
          //   newCurrency = benefitCurrencyObj.local_currency;
          // }

          if (newCurrency > currencyRange.max) {
            newCurrency = currencyRange.max;
          }
          this.selectedObject[scenario].scheme_details.filter(s => s.scheme === scheme)[0].benefit_currency = newCurrency;
          this.selectedObject[scenario].scheme_details.filter(s => s.scheme === scheme)[0].benefit_ppp = benefitCurrencyObj.ppp_equivalent;
        } else {
          _.debounce(async function () {
            if (!target.benefit_currency) {
              return;
            }
            if (target.benefit_currency < currencyRange.min) {
              target.benefit_currency = currencyRange.min;
            } else if (target.benefit_currency > currencyRange.max) {
              target.benefit_currency = currencyRange.max;
            }
            const benefitPercentageObj = await this.getBenefitPercentageObj(selectedObj.country_obj.name, target.benefit_currency, target.scheme, target.week);
            this.selectedObject[scenario].scheme_details.filter(s => s.scheme === scheme)[0].benefit_percent = this.getRoundNumber(benefitPercentageObj.percent, 10);
            this.selectedObject[scenario].scheme_details.filter(s => s.scheme === scheme)[0].benefit_ppp = benefitPercentageObj.ppp_equivalent;
          }, 800);
        }
      }
    },
    inputNumberValidation: function (event, schemeId, tipSection, defaultVal, index, selectedScenario) {
      const val = Number(event.target.value);
      const min = Number(event.target.getAttribute('min'));
      const max = Number(event.target.getAttribute('max'));
      if (val > max || val < min) {
        if (index !== undefined) {
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0][tipSection.name][index] = defaultVal;
        } else {
          this.selectedObject[selectedScenario].scheme_details.filter(s => s.scheme === schemeId)[0][tipSection.name] = defaultVal;
        }
      }
      this.handleSelectChanged();
    },
    orderObj: function (obj, orderField) {
      return _.orderBy(obj, orderField);
    },
    updateSelectedScenario: function (event, schemeId, scenario) {
      event.stopPropagation();
      this.scenarioMode[schemeId] = scenario;
    },
    getScenarioButtonClass: function (schemeId, selectedScenario) {
      const status = this.scenarioMode[schemeId] === selectedScenario;
      let classText = '';
      const selectedClass = 'border border-simulator-tool-text bg-simulation-tool text-white';
      const defaultClass = 'border border-light-blue-grey3 bg-light-blue-grey1 text-grey-additional';
      if (status) {
        classText = selectedClass;
      } else {
        classText = defaultClass;
      }

      return classText;
    },
    getCurrencyText: function (template, country) {
      const currency = country.field_currency_code;
      const result = template.replace('[[currency]]', currency);
      return result;
    },
    updateMode: async function () {
      if (this.mode === 'combined') {
        this.selectedObjectA.scheme_details.map(d => {
          d.is_selected = true;
          return d;
        });
        await this.formatSelectedObjectData();

        this.scenarioMode = {
          70001: 's1',
          70002: 's1',
          70004: 's1',
          70003: 's1'
        };
      } else if (this.mode === 'comparative') {
        this.selectedObjectA.scheme_details.map(d => {
          d.is_selected = true;
          return d;
        });
        await this.formatSelectedObjectData();
      }
    },
    getCustomMarks: function (countryName, schemeId) {
      const result = {};
      const minmaxObj = this.getCurrencyRange(countryName, schemeId);
      const min = minmaxObj.min;
      const max = Math.round(minmaxObj.max / 10) * 10;
      const basicMat = minmaxObj.basicMat;
      const advancedMat = minmaxObj.advancedMat;
      const scalelength = 5;
      const scale = (max - min) / scalelength;
      const tmpValue = min;
      for (let i = 0; i <= scalelength; i++) {
        const newValue = parseFloat((Math.floor((tmpValue + i * scale) * 10) / 10).toFixed(1));

        const labelObj = {
          label: newValue.toLocaleString(),
          labelStyle: {}
        };
        if (max > 10000) {
          labelObj.labelStyle.fontSize = '10px';
        }
        result[newValue] = labelObj;
        // result[newValue] = { label: (i * 20) + '%' };
      }

      if (basicMat > 0) {
        result[basicMat] = {
          label: '',
          style: {
            display: 'block',
            width: '16px',
            height: '14px',
            background: 'white',
            backgroundRepeat: 'no-repeat',
            backgroundImage: 'url(/themes/custom/tbdtheme/assets/dist/img/icons/up_mark_stroke.svg)',
            transform: 'translate(-5px, 4px)',
            borderRadius: '0'
          }
        };

        result[advancedMat] = {
          label: '',
          style: {
            display: 'block',
            width: '16px',
            height: '14px',
            background: 'white',
            backgroundRepeat: 'no-repeat',
            backgroundImage: 'url(/themes/custom/tbdtheme/assets/dist/img/icons/down_mark_fill.svg)',
            transform: 'translate(-5px, -14px)',
            borderRadius: '0'
          }
        };
      }

      return result;
    },
    getCurrencyRange: function (countryName, schemeId) {
      countryName = countryName === 'Türkiye' ? 'Turkey' : countryName;
      const benefitMetadata = this.benefitMetadata.find(d => d.country === countryName);
      let min = 0;
      let max = 0;
      let defaultMat = 0;
      let basicMat = 0;
      let advancedMat = 0;
      if (benefitMetadata) {
        if (String(schemeId) === '70001') {
          min = benefitMetadata.child_min_currency;
          max = benefitMetadata.child_max_currency;
        } else if (String(schemeId) === '70002') {
          min = benefitMetadata.disability_min_currency;
          max = benefitMetadata.disability_max_currency;
        } else if (String(schemeId) === '70003') {
          min = benefitMetadata.oldage_min_currency;
          max = benefitMetadata.oldage_max_currency;
        } else if (String(schemeId) === '70004') {
          min = benefitMetadata.maternity_min_currency;
          max = benefitMetadata.maternity_max_currency;
          // max = Math.round(benefitMetadata.maternity_max_currency / 10) * 10;
          defaultMat = benefitMetadata.maternity_default_currency;
          basicMat = benefitMetadata.maternity_basic_currency;
          advancedMat = benefitMetadata.maternity_advanced_currency;
        }
      }
      const result = { min, max, defaultMat, basicMat, advancedMat };
      return result;
    },
    getRoundNumber (num, precision) {
      return Number(Math.round(num + 'e+' + precision) + 'e-' + precision);
    },
    getCurrencyRoundNumber (num, defaultValue) {
      // console.log(obj);
      if (defaultValue < 1000) {
        return this.getRoundNumber(num, 2);
      } else if (defaultValue < 10000) {
        return this.getRoundNumber(num, 1);
      } else {
        return this.getRoundNumber(num, 0);
      }
    }
  }
};

</script>

<style lang="scss">
#modalSlider .btn-close {
  position: static;
}
.action {
  &:hover {
    cursor: pointer;
    font-weight: 900 !important;
  }
}
.tooltip_text {
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: dotted;
}

.shortcut-btn {
  &:hover {
    font-weight: 900;
    cursor: pointer;
  }
}
.edit-btn {
  text-decoration: underline;
  &:hover {
    font-weight: 900;
    cursor: pointer;
  }
}
</style>
